import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Icon, PaymentForm } from 'components';
import { routes } from 'router';

const TravelBalancePaymentStep = () => {
  const { t } = useTranslation();

  return (
    <div className="lg:grow">
      <Link to={routes.travelBalance.children.validation.path} className="flex items-center gap-2 mb-8">
        <Icon name="angle-left" classes="text-gray-500" />
        {t('buttons.goBack')}
      </Link>

      <PaymentForm />
    </div>
  );
};

export default TravelBalancePaymentStep;
